import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 75rem;
  height: 42rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  cursor: auto;
`;

export const Body = styled.div`
  display: flex;
  height: 87%;
  width: 100%;
`;
export const LeftBody = styled.div`
  width: 52%;
  border-right: 1.5px solid #c4c4c4;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  height: 100%;
`;
export const TaskHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
  justify-content: space-between;
`;

export const LeftScroll = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #eff1f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a9aeb4;
    border-radius: 20px;
    border: none;
  }

  scrollbar-width: thin;
  scrollbar-color: #eff1f5 #a9aeb4;
`;
export const TaskHeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;
export const TaskNameH = styled.span`
  font-weight: 600;
  font-size: 1.21rem;
  line-height: 1.52rem;
  margin-left: 0.5rem;

  max-width: 15rem;

  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }

  color: #212326;
`;

export const LabelIconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.2rem;
  height: 2.25rem;
  justify-content: space-between;

  svg {
    cursor: pointer;

    &.confirm {
      :hover {
        path {
          stroke: #118052;
        }
      }
    }

    &.cancel {
      :hover {
        path {
          stroke: #eb5757;
        }
      }
    }
  }
`;

export const LabelInput = styled.input`
  border: none;
  border-bottom: 2px solid #ccc;
  outline: none;
  transition: border-color 0.3s;
  padding: 5px 0;
  border-color: #40e5a0;
  font-weight: 600;
  font-size: 1rem;
`;

export const TaskStatusH = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  margin-left: 0.5rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "pending"
      ? "#EFF1F5"
      : status === "done"
      ? "#118052"
      : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
      ? "#7E858F"
      : status === "done"
      ? "#EFF1F5"
      : "#D93333"};
`;
export const TaskDateH = styled.div`
  align-items: center;
  display: flex;

  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;

  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  margin-left: 0.3rem;

  ${({ status }) =>
    status === "doing" || status === "late"
      ? css`
          &:hover {
            filter: brightness(0.9);
            cursor: pointer;
          }
        `
      : null}
  background-color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
      ? "#EFF1F5"
      : status === "done"
      ? "#49B446"
      : "#EB5757"};

  color: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};

  path {
    stroke: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};
  }
`;

export const SubTitles = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 2rem;
  display: flex;
  width: 84%;

  color: #585e66;

  div {
    svg {
      height: 1.1rem;
      margin-left: 0.3rem;
    }
  }
`;
export const Description = styled.div`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 0.41rem;
  display: flex;
  width: 100%;
  align-items: center;
  p {
    line-height: 1rem;
    all: unset;
  }

  color: #7e858f;
  &:hover {
    span {
      text-decoration: ${({ description }) =>
        description ? "none" : "underline"};
      cursor: pointer;
    }
  }
`;

export const DescriptionText = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 1.6rem;
    cursor: pointer;
  }
`;
export const TaskWorker = styled.div`
  width: 84%;
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
`;
export const WorkerIcon = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
`;
export const WorkerI = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 800;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #212326;

  margin-left: 0.6rem;
`;
export const WorkerID = styled.span`
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #42464c;

  margin-left: 0.3rem;
`;
export const Attachments = styled.div`
  width: 84%;
  display: flex;
  flex-direction: column;
`;
export const NewAttachments = styled.div`
  width: 84%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const RightBody = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const RightHeader = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2rem 0 1rem 2rem;
  border-bottom: 1.5px solid #c4c4c4;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.2rem;
  color: #212326;
`;

export const RightContent = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #eff1f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a9aeb4;
    border-radius: 8px;
    border: none;
  }
`;

export const RightFooter = styled.div`
  height: 14%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const InputDiv = styled.div`
  width: 100%;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  height: 75%;
`;

export const Footer = styled.div`
  height: 13%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1.5px solid #c4c4c4;
`;
export const Link = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.81rem;
  line-height: 1rem;
  text-decoration-line: underline;

  display: flex;
  align-items: center;

  margin-left: 2rem;
  cursor: pointer;

  color: #585e66;
`;
export const ButtonSpace = styled.div`
  display: flex;
  width: 20.7rem;
  height: 55%;
  justify-content: space-between;
  margin-right: 2rem;

  font-size: 1rem;
`;

export const TaskDescription = styled.div`
  display: flex;
  width: 90%;

  textarea {
    width: 85%;
    font-size: 0.8rem;
    height: 4rem;
    border: ${({ error }) =>
      error ? " 2px solid #eb5757" : "2px solid #d4d6da"};
    border-radius: 8.47434px;
    outline: none;
    resize: none;

    padding: 0.5rem 0.75rem;
  }
`;
export const Options = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  svg {
    cursor: pointer;

    &.confirm {
      :hover {
        path {
          stroke: #118052;
        }
      }
    }

    &.cancel {
      :hover {
        path {
          stroke: #eb5757;
        }
      }
    }
  }
`;
